import { colors } from '@airship-platform/jam-design-tokens';
import { PaletteOptions } from '@mui/material/styles';
import '../base/palette'; // side-effect: keep the MUI augmentation reachable in declaration output
import { basePalette } from '../base/palette';

declare module '@mui/material/styles' {
  interface AirshipPaletteColorOptions {
    primary: string;
    secondary: string;
    accent: string;
    softButton: 'softRed' | 'softBlue' | 'softGold';
    colorName: 'red' | 'blue' | 'gold';
  }

  interface Palette {
    airshipRed?: AirshipPaletteColorOptions;
    airshipGold?: AirshipPaletteColorOptions;
    airshipBlue?: AirshipPaletteColorOptions;
  }
  interface PaletteOptions {
    airshipRed?: AirshipPaletteColorOptions;
    airshipGold?: AirshipPaletteColorOptions;
    airshipBlue?: AirshipPaletteColorOptions;
  }
}

export const platformPalette: PaletteOptions = {
  ...basePalette,
  airshipRed: {
    primary: colors.red[800],
    secondary: colors.red[300],
    accent: colors.red[200],
    softButton: 'softRed',
    colorName: 'red',
  },
  airshipGold: {
    primary: colors.gold[800],
    secondary: colors.gold[300],
    accent: colors.gold[200],
    softButton: 'softGold',
    colorName: 'gold',
  },
  airshipBlue: {
    primary: colors.blue[800],
    secondary: colors.blue[300],
    accent: colors.blue[200],
    softButton: 'softBlue',
    colorName: 'blue',
  },
};
